import { GeoObject } from "../GeoData/GeoObject";
import { ChartData, NameValuePair } from "../ProfileData/ChartData";

export type WeeklyActivity = {
    year : number,
    month : number,
    day : number,
    items: MapItem[];
    nationalCharts: ChartData[],
    nationalStats: ItemWeeklyActivity,
    nationalAbout : ChartData[],
}

export const EmptyWeeklyActivity = () : WeeklyActivity => {
    return {
        year : 0,
        month : 0,
        day : 0, 
        items : [],
        nationalCharts : [],
        nationalStats : {
            hourly : [],
            daily : [],
            week : 0,
            maxDaily : 0,
            maxHourly : [],
            levels : [],
            activity : {
                uniques : 0,
                comments : 0,
                quiz : 0,
                reactions : 0,
                creative : 0,
                audience : 0,
                consumedTotal : 0,
                consumed : []
            }
        },
        nationalAbout : [],
    }
}

export type GenerativeMapData = {
    nationalEngagement: NationalActivity;
    stateCharts: { [key: string]: ChartData[] };
    nationalCharts: ChartData[];
    aboutNational : ChartData[];
    aboutStates: { [key : string] : ChartData[]};
}

export type MapItem ={
    geo : GeoObject;
    charts : ChartData[];
    stats : ItemWeeklyActivity;
    about : ChartData[];
}

export type ActivityStats = {
    uniques: number;
    reactions: number;
    comments: number;
    quiz: number;
    creative: number;
    audience: number;
    consumedTotal: number;
    consumed: NameValuePair[];
};

export type ItemWeeklyActivity = {
    hourly: number[][],
    daily: number[],
    week: number,
    maxDaily: number,
    maxHourly: number[],
    levels : number[],
    activity: ActivityStats;
}


export type NationalActivity = {
    national: ItemWeeklyActivity,
    states: { [key: string]: ItemWeeklyActivity },
}
